var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "material-design-icon printer-icon",
      attrs: {
        "aria-hidden": _vm.decorative,
        role: "img",
        "aria-label": _vm.title
      }
    },
    [
      _c(
        "svg",
        {
          staticClass: "material-design-icon__svg",
          attrs: {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: _vm.fillColor
          }
        },
        [
          _c("title", [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M18,3H6V7H18M19,12C18.45,12 18,11.55 18,11C18,10.45 18.45,10 19,10C19.55,10 20,10.45 20,11C20,11.55 19.55,12 19,12M16,19H8V14H16M19,8H5C3.34,8 2,9.34 2,11V17H6V21H18V17H22V11C22,9.34 20.66,8 19,8Z"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-95a8dc10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95a8dc10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-material-design-icons/printer.vue
// module id = 8c0I
// module chunks = 1